<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail input-scan-page" @hidden="resetModal" scrollable
		:no-close-on-backdrop=true @ok="addButtonAction" title="Part Good Receipt Detail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
					<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''"
						label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
					<app-input-textbox id="fieldset-po-qty-outstanding" label-cols-lg="12" label="PoQtyOutstanding"
						label-for="input-po-qty-outstanding" size="sm" :model.sync="model.poQtyOutstanding"
						:isRequired="true" :state="validateState('poQtyOutstanding')"
						:errorMessage="getErrorMessage(errorMessage.poQtyOutstanding, 'poQtyOutstanding')" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-qty-received" label-cols-lg="12" label="QtyReceived"
						label-for="input-qty-received" size="sm" :model.sync="model.qtyReceived" />
					<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark" label-for="input-remark"
						size="sm" :model.sync="model.remark" />
				</b-col>
				<b-col cols="12" lg="6">

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
			<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
			<b-overlay :show="isBusy" rounded opacity="0.6" spinner-small spinner-variant="primary" class="float-right ">
				<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
					Save
				</b-button>
			</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
::v-deep .modal-dialog {
	width: 70% !important;
}

@media (max-width: 576px) {
	::v-deep .modal-dialog {
		width: calc(100%) !important;
	}
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import focusInput from '@/mixins/focusInputMixin';
import PartGoodReceiptDetail from '@/models/PartGoodReceipt/PartGoodReceiptDetail';
import PartGoodReceiptDetailFilter from '@/filters/PartGoodReceipt/PartGoodReceiptDetailFilter';

import PartGoodReceipt from '@/models/PartGoodReceipt/PartGoodReceipt';
import PartGoodReceiptFilter from '@/filters/PartGoodReceipt/PartGoodReceiptFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputScan from '@/components/AppInputScan';
export default {
	props: ['model', 'modelId', 'openPopup', 'addButtonMethod', 'resetMethod', 'parentLabelInfo', 'parentValueInfo'],
	components: {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterView,
		AppInputScan,
	},
	mixins: [validationMixin, focusInput],
	validations: {
		model: {
			partId: { required },
			poQtyOutstanding: { required },
		}
	},
	data() {
		return {
			errorMessage: {
				partId: { required: "Part Code is Required." },
				poQtyOutstanding: { required: "PoQtyOutstanding is Required." },
			},
			parts: [],
			isBusy: false,
		}
	},
	methods: {
		getPartGoodReceiptDetail: async function (id) {
			this.isBusy = true;
			PartGoodReceiptDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
				})
				.catch(error => { });
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;



				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model);
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},
		scanPart() {
			this.focusInput(this, "fieldset-part");
		},

	}, beforeMount() {
		//this.getParts();
	},
	async mounted() {
	},
	watch: {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPartGoodReceiptDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				//this.getPurchaseOrderDetails();
				this.getParts();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPartGoodReceiptDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup: {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) { }
		},
	}
}
</script>
